//  FreightTypes.aspx
var FreightTypes = (function(backOffice, $){
    backOffice.FreightTypes = (function(){
        function confirmDelete(){
            if (confirm("Are you sure you wish to delete this Freight Type?")){
                return BackOffice.ToggleLoader(true);
            }
            else{
                return false;
            }
        }

        function confirmActivate(action){
            var value = "";
            if (action === "Create")
                value = $("#tbxFreightType").val();
            else if (action === "Update"){
                value = $("#tbxFreightTypeName").val();
            }
            var result = false;
            $.ajax({
                async: false,
                url: window.location.origin +
                    "/dotnet/admin/api/doesexistsdeletedfreighttype?freightTypeName=" +
                    value,
                dataType: "json",
                contentType: "application/json charset=UTF-8",
                success: function(doesFreightTypeExists){
                    if (doesFreightTypeExists){
                        if (confirm(
                            "Specified Freight Type already exists as a previously disabled value. Do you wish to re-activate this Freight Type?")
                        ){
                            BackOffice.ToggleLoader(true);
                            result = true;
                        }
                        else{
                            result = false;
                        }
                    }
                    else{
                        BackOffice.ToggleLoader(true);
                        result = true;
                    }
                }
            });
            return result;
        }

        return $.extend(backOffice.FreightTypes,
            {
                ConfirmDelete: confirmDelete,
                ConfirmActivate: confirmActivate
            });
    })();

    return backOffice.FreightTypes;
})(BackOffice || {}, jQuery);